// extracted by mini-css-extract-plugin
export default {"boardWrapper":"BoardPage_boardWrapper__w0Pku","body":"BoardPage_body__ElgPY","bodyWrapper":"BoardPage_bodyWrapper__-m43Y"};